import { ShapeBaseAttribute } from './base';

export class AppWidgetAttribute extends ShapeBaseAttribute {
  // shape: 'Square' | 'Rectangle' | 'Circle' = 'Rectangle';
  // colorMode: 'Dark' | 'Light' = 'Dark';
  // currentDisplay: 'sunRiseAndSet' | 'heartRate' | 'wheather' = 'sunRiseAndSet';
  appWidgetID = '';
  // appWdiget = '';

  resources: {
    /**
     * 容器预览图，用于负责功能容器
     */
    appWidgetPreview?: LayerResourceItem;
  } = {};
}
